import recommend from './news/recommend.action';
import comment from './news/comment.action';
import downloadBar from './news/downloadBar.action';
import common from './news/common.action';
import userInfo from './news/userinfo.action';
import article from './news/article.action';
import dialog from './news/dialog.action';
import smp from './news/smp.action';
import search from './news/search.action';
import videoInfo from './video/videoInfo.action';
import recommendVideos from './video/recommand.action';
import videoCommon from './video/videoCommon.action';
import shareCommon from './common/share.action';
import shortContents from './shortContent/content.action';
import newComment from './common/commentNew.action';
import recommendPop from './news/rencommendPop.action';
import secSharePop from './common/secSharePop.action';
import clipboard from './eCommerceFission/clipboard.action';
import activity from './eCommerceFission/activity.action';
export default {
  recommend,
  comment,
  common,
  userInfo,
  downloadBar,
  article,
  dialog,
  smp,
  search,
  videoInfo,
  recommendVideos,
  videoCommon,
  shareCommon,
  shortContents,
  newComment,
  recommendPop,
  secSharePop,
  clipboard,
  activity
}